import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./BreadCrumbs.css";
import arrow from '../../../assets/images/Breadcumbs_arrow.svg'

class BreadCrumbs extends Component {
  path = "";
  link = "";

  constructor(props) {
    super(props);

    this.state = {
      breadcrumbs: this.props.breadcrumbs
    };

    var array = this.state.breadcrumbs.split("/");

    this.link = "";

    var arr = array[0].length === 0 ? array.shift() : null;

    arr = array[0].length === 2 ? array.shift() : null;

    for (var element in array) {
      if (array[element].length) {
        if (parseInt(element, 10) + 1 < array.length) {
          this.link += "/" + array[element];
        }

        array[element] =
          array[element].charAt(0).toUpperCase() + array[element].slice(1);

        if (this.path.length) {
          this.path += " / " + array[element];
        } else {
          this.path += array[element];
        }
      }
    }
  }
  render() {
    // console.log(this.props, "dsds");
    let bredRender = null;
    if (this.props.both) {
      bredRender = (
        <div
          className="BreadCrumbs"
          style={{
            display: "flex"
          }}
        >
          <div
            className="breadcrumbs_link"
            style={{
              cursor: "pointer"
            }}
            onClick={this.props.history.goBack}
          >
            <img style={{width: "20px", verticalAlign: "baseline"}} src={arrow} alt="back arrow"/>
            <span className="breadcrumbs_back">
              <b>{this.props.title}</b>
            </span>
          </div>
          {this.props.newBread ? (
            this.props.newBread.map((elem, i) => {
                if (i == this.props.newBread.length - 1) {
                  return (
                    <Link key={i} to={elem.url} className="breadcrumbs_link">
                      <span
                        className={`breadcrumbs_path--new breadcrumbs_path--${i}`}
                      >
                        {" "}
                        {elem.name}
                      </span>
                    </Link>
                  );
                }
                return (
                  <Link key={i} to={elem.url} className="breadcrumbs_link">
                    <span
                      className={`breadcrumbs_path--new breadcrumbs_path--${i}`}
                    >
                      {elem.name}
											<span style={{
												paddingRight:'4px',
												paddingLeft:'4px',
												display:'inline-block'
											}}>/</span>
                    </span>
                  </Link>
                );

            })
          ) : (
            <Link to={this.link} className="breadcrumbs_link">
              <span className="breadcrumbs_path">{this.path}</span>
            </Link>
          )}
        </div>
      );
    } else if (this.props.back_arrow) {
      bredRender = (
        <div className="BreadCrumbs">
          <div
            className="breadcrumbs_link"
            style={{
              cursor: "pointer",
              display: "flex"
            }}
            onClick={this.props.history.goBack}
          >
            <img style={{width: "20px", verticalAlign: "baseline"}} src={arrow} alt="back arrow"
            />
            <span className="breadcrumbs_back">
              <b>{this.props.title}</b>
            </span>
          </div>
        </div>
      );
    } else if (this.props.only_breadcrumbs) {
      bredRender = (
        <div className="BreadCrumbs">
          <Link to={this.link} className="breadcrumbs_link">
            <span className="breadcrumbs_path">{this.path}</span>
          </Link>
        </div>
      );
    } else {
      return null;
    }
    return <div className="container">{bredRender}</div>;
  }

}
export default withRouter(BreadCrumbs);



// WEBPACK FOOTER //
// ./src/Components/Elements/BreadCrumbs/BreadCrumbs.js